/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Contact_Discord_NudgeInputs */



/**
* | output |
* | --- |
* | "Link a Discord login in the Account tab to give members a second way to reach you." |
*
* @param {Profile_Contact_Discord_NudgeInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_contact_discord_nudge = /** @type {((inputs?: Profile_Contact_Discord_NudgeInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Contact_Discord_NudgeInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Liez un compte Discord dans l'onglet Compte pour offrir aux membres un second moyen de vous joindre.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Vincula una cuenta de Discord en la pestaña Cuenta para dar a los miembros una segunda forma de contactarte.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Vincule uma conta Discord na aba Conta para dar aos membros uma segunda forma de contatá-lo.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Collega un account Discord nella scheda Account per dare ai membri un secondo modo di contattarti.")
	return /** @type {LocalizedString} */ ("Link a Discord login in the Account tab to give members a second way to reach you.")
});